import { render, staticRenderFns } from "./program-grade.vue?vue&type=template&id=522d8a1c&scoped=true&"
import script from "./program-grade.vue?vue&type=script&lang=js&"
export * from "./program-grade.vue?vue&type=script&lang=js&"
import style0 from "./program-grade.vue?vue&type=style&index=0&id=522d8a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d8a1c",
  null
  
)

export default component.exports